import _ from "lodash";
import { PRINT_CONFIG } from '../actions/types';
import { constants } from '../Constants/constants';

const INITIAL_STATE = {
    ui: {
        printConfig: _.cloneDeep(constants.PRINT_CONFIG_INPUT)
    }
}

const printConfigReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case PRINT_CONFIG.SET_PRINT_CONFIG_DEFAULT:
            return Object.assign({}, INITIAL_STATE)
        case PRINT_CONFIG.SET_PRINT_CONFIG:
        case PRINT_CONFIG.SET_PRINT_CONFIG_VALUE:
            return Object.assign({}, {
                ...state,
                ui: {
                    ...state.ui,
                    printConfig: action.printConfig
                }
            })
        default:
            return state
    }
}

export default printConfigReducer